// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2Vk83","buttons":"PendingPaymentAlert_buttons__2_ovR"};